export const metatagionas = {
  Page: {
    "meta-tagi": {
      Title:
        "Tanie wakacje z TravelOne.pl - rezerwuj wczasy i wakacje last minute",
      Description:
        "TravelOne.pl ••• Lato 2023 ••• wczasy pobytowe last minute, wycieczki, hotele, weekend majowy, domy wakacyjne, bilety lotnicze, egzotyka, wyjazdy na narty",
      Keywords: []
    }
  }
};
